import Vue from 'vue'
import Router from 'vue-router'
import PcIndex from '@/components/PcIndex'
import MIndex from '@/components/MIndex'
//import swiper from '@/components/swiper'
Vue.use(Router)
export default new Router({
   routes: [
    {
      path: "/pc_index", // pc端首页
      name: PcIndex,
      component: PcIndex
    },
    {
      path: '/m_index', // 手机端首页
      name: MIndex,
      component: MIndex
    },
   
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js